import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import {MatSliderModule} from '@angular/material/slider';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// Main Module
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { TextMaskModule } from 'angular2-text-mask';
// Global Components
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { NotFoundComponent } from './common/not-found/not-found.component';
// Module Components
import { AppScrollerDirective } from './_directives/scroller.directive';
import * as $ from 'jquery';
import { LoginComponent } from './modules/login/login.component';
// Common Components
import { Tab, Tabs } from './common/tabs/index';
import { CustomAttributeDirective } from './_directives/custom-attribute.directive';
import { HomeComponent } from './modules/home/home.component';
import { StartComponent } from './modules/start/start.component';
import { RegisterComponent } from './modules/login/register/register.component';
import { NewUserComponent } from './modules/login/new-user/new-user.component';
import { LandingPageComponent } from './modules/login/landing-page/landing-page.component';
import { RedeemComponent } from './modules/redeem/redeem.component';
import { DownloadComponent } from './modules/my-content/download/download.component';
import { FaqComponent } from './modules/faq/faq.component';
// Services
import {
    AuthenticationService,
    AuthGuard,
    DataService,
    NewUserGuradService,
    TokenInterceptorService,
    WindowRefService
} from './_services/index';
// import {AlertComponent} from "./_directives/alert.component";
import { AlertComponent } from './_directives/index';
import { MyContentComponent } from './modules/my-content/my-content.component';
import { OrderByPipe } from './_pipes/order-by.pipe';
import { FilterPipe } from './_pipes/filter.pipe';
import { MyAccountComponent } from './modules/my-account/my-account.component';
import { PasswordResetComponent } from './modules/login/password-reset/password-reset.component';
import { PasswordChangeComponent } from './modules/login/password-change/password-change.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TreeviewModule } from 'ngx-treeview';
import { ToastOptions } from 'ng2-toastr';

export class CustomOption extends ToastOptions {
    animate = 'fade'; // you can override any options available
    newestOnTop = false;
    //dismiss = 'click';
    showCloseButton = true;
    positionClass = 'toast-top-center';
}
import { CustomScrollDirective } from './custom-scroll.directive';
import { ElipsesDirective } from './_directives/elipses.directive';
import { HttpProgressInterceptor } from './_services/http-progress-interceptor.service';
import { FileSizeFormatterPipe } from './_pipes/file-size-formatter.pipe';
import { TreeViewComponent } from './common/tree-view/tree-view.component';
import { ContntGridViewComponent } from './common/contnt-grid-view/contnt-grid-view.component';
import { FileTypeIconPipe } from './_pipes/file-type-icon.pipe';
import { SafePipe } from './_pipes/safe.pipe';
import { AudioPlayerComponent } from './common/audio-player/audio-player.component';
import { PdfViewerComponent } from './common/pdf-viewer/pdf-viewer.component';
import { ViewContentComponent } from './modules/my-content/view-content/view-content.component';
import { TreeFilterPipe } from './_pipes/tree-filter.pipe';
import { ScaleTextPipe } from './_pipes/scale-text.pipe';
import { XlsViewerComponent } from './common/xls-viewer/xls-viewer.component';


@NgModule({
    declarations: [
        AppComponent,
        AlertComponent,
        HeaderComponent,
        FooterComponent,
        LoginComponent,
        NotFoundComponent,
        Tab,
        Tabs,
        CustomAttributeDirective,
        HomeComponent,
        StartComponent,
        NewUserComponent,
        RedeemComponent,
        DownloadComponent,
        FaqComponent,
        MyContentComponent,
        OrderByPipe,
        FilterPipe,
        MyAccountComponent,
        PasswordResetComponent,
        PasswordChangeComponent,
        CustomScrollDirective,
        RegisterComponent,
        LandingPageComponent,
        ElipsesDirective,
        AppScrollerDirective,
        FileSizeFormatterPipe,
        TreeViewComponent,
        ContntGridViewComponent,
        FileTypeIconPipe,
        SafePipe,
        AudioPlayerComponent,
        PdfViewerComponent,
        ViewContentComponent,
        TreeFilterPipe,
        ScaleTextPipe,
        XlsViewerComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgbModule.forRoot(),
        HttpModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        ToastModule.forRoot(),
        NgxSpinnerModule,
        TextMaskModule,
        TreeviewModule.forRoot(),
        MatSliderModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatTooltipModule,
        PdfViewerModule
    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
            // useClass: PathLocationStrategy
        },
        {
            provide: ToastOptions,
            useClass: CustomOption
        },
        AuthGuard,
        NewUserGuradService,
        DataService,
        AuthenticationService,
        WindowRefService,
        OrderByPipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
            // },
            // {
            //     provide: HTTP_INTERCEPTORS,
            //     useClass: HttpProgressInterceptor,
            //     multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./public/app/app.module.ts